import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';

// The Payment icons have a standard size 40 x 24 and chroma
const Amex: FC<IconV2Props> = ({ icon, className }) => (
  <svg
    width="40"
    height="24"
    viewBox="0 0 40 24"
    xmlns="http://www.w3.org/2000/svg"
    className={cn(className, `svg-icon--${icon}`)}
  >
    <g fill="none" fillRule="evenodd">
      <path
        d="M0 0h40v24H0V0Zm1 1v22h38V1H1Z"
        fill="#D5D6D6"
        fillRule="nonzero"
      />
      <path
        d="m10.782 9.001 2.718 6h-1.81l-.5-1.202H8.274l-.502 1.202H6l2.72-6h2.062ZM21.437 9v6H19.85v-4.421l-1.683 4.42h-1.392l-1.688-4.42v4.42H13.5V9l2.527.009 1.47 3.868L18.93 9h2.507Zm1.063 6V9h7l1.537 1.877L32.58 9h1.922l-2.548 3 2.526 3h-1.999l-1.493-1.848L29.53 15H22.5Zm5.179-5.79v1.132h-3.575v1.026h3.492v1.263h-3.492v1.066h3.576l-.001 1.162 2.403-2.822-2.403-2.827ZM9.727 10.397l-.892 2.1h1.78l-.888-2.1Z"
        fill="#016FD0"
      />
    </g>
  </svg>
);

export default Amex;
